import styled from 'styled-components';
import { rem } from '../../../utils/style';
import { COLORS } from '../../../constants/style/color';

export const PermissionConfirmScrollWrapper = styled.div`
  margin-top: ${rem(12)};
  max-height: ${rem(150)};
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 7px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
